import { BlocksIconTrendingUp } from 'blocks-nextjs/blocks-web-components/components/icon/icons/trending-up';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconTrendingUp = createComponent({ react: React, tagName: 'cat-icon-trending-up', elementClass: BlocksIconTrendingUp });
